var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-my-projects-tabs"},[_c(_setup.BCXContentAreaTabs,{staticClass:"c-tabs",attrs:{"tabs":_setup.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }